import Decimal from 'decimal.js'

export const mull00 = (num) => new Decimal(+num).mul(100).toNumber()
export const div100 = (num) => new Decimal(+num).div(100).toNumber()
export const numberDiv100Fixed2 = (num) => new Decimal(+num).div(100).toFixed(2)
export const mul = (num, dep) => new Decimal(+num).mul(+dep).toNumber()
export const div = (num, dep) => new Decimal(+num).div(+dep).toNumber()
export const isTrueNumber = (num) => /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(num) // 非负数，可以为小数和0
